// extracted by mini-css-extract-plugin
export var secondaryList = "PostsModuleMixedLayout-module--secondaryList--D9cQo";
export var filterForm = "PostsModuleMixedLayout-module--filterForm--O+9qP";